import TagManagerListingPage from './TagManagerListingPage';
import { jsx as _jsx } from "react/jsx-runtime";
const TagManagerContainer = () => {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(TagManagerListingPage, {})
  });
};
export default TagManagerContainer;